import { render, staticRenderFns } from "./SlyderC.vue?vue&type=template&id=4d9d7e66&scoped=true&lang=pug&"
import script from "./SlyderC.vue?vue&type=script&lang=js&"
export * from "./SlyderC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9d7e66",
  null
  
)

export default component.exports